import styled from "styled-components";

export const MenuItem = styled.li`
  align-items: center;
  display: flex;
  gap: 10px;
  padding: 0 ${({ theme }) => theme.padding.small};
`;
